import { render, staticRenderFns } from "./NationalityDropdown.vue?vue&type=template&id=585d2d8a"
import script from "./NationalityDropdown.vue?vue&type=script&lang=js"
export * from "./NationalityDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports